import * as React from "react";
import type { SVGProps } from "react";
const SvgX03 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeWidth={2}
      d="M17 7 7 17m10 0L7 7"
    />
  </svg>
);
export default SvgX03;
